/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "sjnxgixOcMQ",
    title: "Harry Potter Stars Who Are No Longer The Same",
    creator: "X-List",
    description: `These Harry Potter Stars Are NO LONGER The Same!

    On X List we will be providing daily family friendly content covering everything trend related on youtube. Some videos you can expect are videos covering Top 10s, Top 5s, List videos, and more. If you want to submit video topics for the channel you can comment them on my videos because I read all the comments!
    
    Thank you for watching! Make sure to share, and subscribe for more Top Videos! I hope you enjoyed!`,
    category: "Facts",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLSWwCwNMkO_N6r4TfQITz7yIa4TVSq-alOtjl1obg=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "AQJPbaSkEms",
    title:
      "FilterCopy | If You Acted Like Harry Potter Characters In Real life | ft. Madhu Gudi",
    creator: "FilterCopy",
    description: `We solemnly swear we are up to no good.

     Hey guys! If you are a Potter Head, check this video out and let us know what you think about it in the comments below!`,
    category: "Funny",
    profile:
      "	https://yt3.ggpht.com/ytc/AKedOLTwQUwbdqTyU1FbjltMB_4gYp1kDnAKmGGNazseBA=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "9_GEOngVGcY",
    title: "TOP 10 Most Hated Characters in Harry Potter | Explained in Hindi",
    creator: "Anjali Govil",
    description:
      " Top 10 characters in Harry Potter which fans hated most as per books and movies. ",
    category: "Facts",
    profile:
      "	https://yt3.ggpht.com/ytc/AKedOLQmvAn-4uyne2U7Gq1j11tGEBRW8ND35N3qmxYhKg=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "8lcaOicMVGM",
    title: "Tom Felton Won't Be The Same Anymore After Harry Potter |⭐ OSSA",
    creator: "OSSA",
    description: 
      "Draco Malfoy became one of the beloved Harry Potter characters despite Joanne Rowling's wish.",
    category: "Facts",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLQmvAn-4uyne2U7Gq1j11tGEBRW8ND35N3qmxYhKg=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "TRG7HwiprZU",
    title: "Alan Rickman reflects on 10 years of Harry Potter",
    creator: "The 92nd Street Y, New York ",
    description:
      " Alan Rickman visited us recently to talk about his new film A Little Chaos with Reel Pieces ",
    category: "Interview",
    profile:
      "	https://yt3.ggpht.com/j0YfoqpCrfME-a2LmHRsbInoYSfw-SxBk-G8fCh9mndVOTWtJ-cGdXBk8A1QNs76TklNm2yR2w=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "eVffeHeHEFU",
    title:
      "Harry Potter Reunion Trailer! Emma Watson TEARS UP Reuniting With Co-Stars",
    creator: "Entertainment Tonight",
    description: `Daniel Radcliffe, Emma Watson, Rupert Grint and their castmates are seen all together in the first trailer for ‘Harry Potter 20th Anniversary: Return to Hogwarts.’ The highly-anticipated retrospective features appearances from Tom Felton, Helena Bonham Carter, Gary Oldman, Ralph Fiennes and more familiar faces from the franchise. ET chats with Rupert, who plays Ron Weasley, who explains why the reunion was so emotional. ‘Harry Potter 20th Anniversary: Return to Hogwarts’ premieres Jan. 1 on HBO Max.`,
    category: "Interview",
    profile:
      "https://yt3.ggpht.com/ytc/AKedOLTqXgmsFQawqF7Sisoz1o8ubEAc3to7E-IfAC0khQ=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "Mg3oCq_E8Os",
    title:
      " Raw footage from J.K. Rowling interview aired on October 8th, 1998, ITN. ",
    creator: "The Rowling Library",
    description: `Raw footage from an interview made in Edinburgh, Scotland, with J.K. Rowling, in 1998.
    The interview segment was aired on October 8th, 1998, on ITN, and was around 3 minutes long.
    This is the entire footage from that interview session.
    
    #HarryPotter #JKRowling
    
    No commercial purposes. Only to keep an archive of J.K. Rowling's appearances. `,
    category: "Interview",
    profile:
      "	https://yt3.ggpht.com/ytc/AKedOLQt2Nkv3AeWRNCqdBThxo8EQlIWy-bVuVR3biJo=s88-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "dpsmKKUah4M",
    title: "Only Harry Potter Fans Will Find Funny",
    creator: "Whatever Potter",
    description: "Only Harry Potter Fans Will Find Funny",
    category: "funny",
    profile:
      "	https://yt3.googleusercontent.com/ytc/AGIKgqNvNejHvDPV4gG2uB-S7UUiyi-11wuhGbxNW75crg=s176-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "B18ss3dbRAI",
    title: " Harry Potter: Hogwarts in 2020",
    creator: "The Wrap Zone",
    description: `Harry Potter - Hogwarts in 2020
      It's back to school time and students are getting used to meeting up on Zoom calls to do their learning this year. We found it funny to imagine if the wizards of Hogwarts were doing the same thing. So, set in the current muggle borne health crisis, Harry Potter and his classmates meet up for a socially distant Zoom class with good ol' professor Snape
      `,
    category: "Funny",
    profile:
      "	https://yt3.ggpht.com/ytc/AKedOLT6FsfPPHGsiCVZ4I0HdowuISHkHgOpVMinEvYS7A=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "wl7Ckc0iILg",
    title: "Harry Potter (A Funny Animated Spoof)",
    creator: "Karan Animations",
    description: `A Harry Potter and the Sorcerer's Stone funny animation Spoof. In this Video Harry is a Punjabi Guy called "Hari Putter" is on adventure with his Friends Hermione and Ron. Made using Adobe Flash and Premiere pro with my Laptop and Mouse. Let me know your favorite Dialogue of the video and don't forget to share with your Hogwarts Friends:). 
    Stay Tuned more to come in the future!
    `,
    category: "Funny",
    profile:
      "https://yt3.ggpht.com/M87neGn192YBZObUNPlWH3LUJOGI7Swl42HCtJPGKjuQnMjUsqrtN_Crj3BzslXCfVrgOJVs8g=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "P6mJTbyN9vI",
    title: "Harry Potter Students Vs. Professors Bloopers",
    creator: "TheThings",
    description: `We are all for some Harry Potter bloopers - and this time it's not just the students. Even the Professors at Hogwarts goofed off a little bit - sometimes at the student’s expenses.
    `,
    category: "Funny",
    profile:
      "https://yt3.ggpht.com/ytc/AMLnZu_S_V2QQxHyck2B0r_lvtovB-IyPZQMaTv48lccww=s48-c-k-c0x00ffffff-no-rj",
  },
  {
    _id: "u37o8qD6yXg",
    title: "Top 10 Biggest Reveals in Harry Potter",
    creator: "MsMojo",
    description: `Our return to Hogwarts unleashed a chamber of secrets. For this list, we’ll be looking at details and behind-the-scenes facts from the “Harry Potter” reunion, some of which hadn’t been revealed before. Our countdown includes Daniel Radcliffe wrote a love letter to Helena Bonham Carter, Jason Isaacs originally auditioned for Gilderoy Lockhart, the Great Hall’s Floating candles were originally real, and more!`,
    category: "Facts",
    profile:
      "	https://yt3.ggpht.com/ytc/AMLnZu-HCqH_dEb7miTjjVd_vrvu3nKiZ4Ng18HanZ7ZQQ=s68-c-k-c0x00ffffff-no-rj",
  },
];
